import { EMPTY_STRING } from '../../../../constants/common'

export function getItemText({ exportLinkTitleKey, index, t }) {
  return (
    `${t(exportLinkTitleKey)}` + (index > 1 ? ` ${index + 1}` : EMPTY_STRING)
  )
}
